export const types = {
  'Other':                '',
  'Backpacking':          '',
  'Ballooning':           '',
  'Birdwatching':         'WALKING',
  'Walking':              'WALKING',
  'Driving':              'DRIVING',
  'Bicycling':            'BICYCLING',
  'Bungee jumping':       '',
  'Camping':              '',
  'Canoeing':             '',
  'Cycling':              'BICYCLING',
  'Cyclo-touring':        'BICYCLING',
  'Road-Trip':            'DRIVING',
  'Canyoning':            '',
  'Flying':               '',
  'Geocaching':           '',
  'Gliding':              '',
  'Horseback riding':     '',
  'Hunting':              '',
  'Hitchhiking':          'DRIVING',
  'Ice climbing':         '',
  'Jetskiing':            '',
  'Kayaking':             '',
  'Motorbike expedition': '',
  'Mountain biking':      '',
  'Mountain climbing':    '',
  'Mushroom hunting':     '',
  'Orienteering':         '',
  'Paintball':            '',
  'Paragliding':          '',
  'Paramotoring':         '',
  'Parasailing':          '',
  'Rock climbing':        '',
  'Running':              'WALKING',
  'Safari':               '',
  'Safari park':          'DRIVING',
  'Sailing':              '',
  'Sandboarding':         '',
  'Scuba diving':         '',
  'Sightseeing':          'WALKING',
  'Skiing':               '',
  'Skydiving':            '',
  'Snorkeling':           '',
  'Snowboarding':         '',
  'Snowshoeing':          'WALKING',
  'Sport fishing':        '',
  'Swimming':             '',
  'Tree climbing':        '',
  'Trekking':             '',
  'Waterskiing':          '',
  'Whitewater rafting':   '',
  'Windsurfing':          '',
  'Wingsuit flying':      '',
}
